module.exports = __webpack_public_path__ + "static/media/faq-iocn.c6d2984c.svg";